import { Component, TemplateRef, ViewChild, ChangeDetectorRef, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../service/login/login.service';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable, BehaviorSubject, debounceTime, startWith, switchMap, tap, merge, distinctUntilChanged } from 'rxjs';
import { PlanProtectionService } from '../../service/plan-protection/plan-protection.service';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { PlanProtectionDialogComponent } from '../../dialogs/plan-protection-dialog/plan-protection-dialog.component';
import { NuevoPlanProtectionDialogComponent } from '../../dialogs/nuevo-plan-protection-dialog/nuevo-plan-protection-dialog.component';
import { SpinnerService } from '../../service/spinner-service/spinner.service';
import { ErrorDialogComponent } from '../../../app/dialogs/error-dialog/error-dialog.component';

@Component({
  selector: 'plan-protection-en-tramite',
  templateUrl: './plan-protection-en-tramite.html',
  styleUrls: ['./plan-protection-en-tramite.scss']
})

export class PlanProtectionEnTramiteComponent { 

  @ViewChild('customTemplate', { static: true }) customTemplate: TemplateRef<any>;
  @ViewChild('vendedorTemplate', { static: true }) vendedorTemplate: TemplateRef<any>;

  filtros = true
  isLoadingView: boolean = false
  total: number;
  filter = new FormControl();
  selectFilter = new FormControl();
  page: number = 1;
  pageSize: number = 20;
  elements$: Observable<any>
  pag: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  paginator$ = this.pag.asObservable();
  sort: any = { active: "position", direction: 'desc' };
  isLoadingResults = true;
  listaProveedores = []
  activeFilter = 1
  folioFilter = ''
  clienteFilter = ''
  celularFilter = ''
  ordenVentaFilter = ''
  sucursalFilter = ''
  ovFilter = ''
  sucfiLTER = ''
  columns = []
  rows = [];
  temp = [];
  ColumnMode = ColumnMode;
  code1: any;
  isDesktop: boolean = false

  sucursales = []
  sucursalesFiltradas = []
  selectedOptionsSucursales = []

  elementos = [20, 40, 100]
  paginator: IPaginator = { itemsPerPage: 40, pageNumber: 1 }
  pagination: IPagination;
  pages: Array<any> = [];
  filters: any = {};
  columnas: Array<any> = [
    {
      title: "Folio PP", key: "folio", orderby: "folioPP"
    },
    {
      title: "Orden Venta", key: "ordenVentaId", orderby: "ordenVentaId"
    },
    {
      title: "Sucursal", key: "sucursal", orderby: "sucursal"
    },
    {
      title: "Nombre Cliente", key: "nombreCliente", orderby: "nombreCliente"
    },
    {
      title: "Celular Cliente", key: "celular", orderby: "celular"
    },
    {
      title: "Fecha Venta", key: "fechaVenta", orderby: "fechaVenta"
    },
    {
      title: "Fecha de Expiración", key: "fechaVigencia", orderby: "fechaVigencia"
    }
  ]

  constructor(private ppService: PlanProtectionService, private router: Router, private dialog: MatDialog, private cdr: ChangeDetectorRef, private spinnerService: SpinnerService){
    this.getSucursales()
    const ua = navigator.userAgent;

    if (/mobile/i.test(ua)) {
      this.isDesktop = false;
    } else if (/tablet/i.test(ua)) {
      this.isDesktop = false;
    } else {
      this.isDesktop = true;
    }
    // this.getData(1)
  }
  
  getSucursales(){
    if(localStorage.getItem('profile') !== 'Gerente'){
      this.getData(1)
    }else{
      this.ppService.getSucursales({}).subscribe(
        data => {
          const idsGuardados: number[] = JSON.parse(localStorage.getItem('sucursalId') || '[]');
          const sucursalesFiltradas = data.filter(sucursal =>
            idsGuardados.includes(sucursal.sucursalId)
          );
          this.sucursales = sucursalesFiltradas
          this.sucursalesFiltradas = sucursalesFiltradas
          this.selectedOptionsSucursales = sucursalesFiltradas
          this.getData(1)
        }
      )
    }
    
  }

  isGerente(){
    return localStorage.getItem('profile') === 'Gerente'
  }
  
  ngOnInit(): void {
    if(this.isGerente()){
      let vendedorColumn = {
        title: "Nombre Vendedor", key: "nombreVendedor", orderby: "nombreVendedor"
      }
      this.columnas.splice(1, 0, vendedorColumn)
    }
    const obsFilter = this.filter.valueChanges.pipe(
      debounceTime(200),
      startWith(null),
      switchMap((res: string) => this.ppService.getLength(res)),
      tap((res: number) => {
        this.total = res;
      })
    );

    this.elements$ = merge(obsFilter, this.paginator$)
      .pipe(
        distinctUntilChanged(),
        tap(_ => { this.isLoadingResults = true }),
        switchMap(res => {
          return this.ppService.getData(
            this.page,
            this.pageSize,
            // this.filter.value,
            this.sort.active,
            this.sort.direction
          );
        }),
        tap(_ => (this.isLoadingResults = false))
      )
  }

  getDataEndpoint(){
   
  }
  
  getData(opc){

    this.spinnerService.setMensaje('Cargando Plan Protection Pendientes')
    this.spinnerService.show()
    let body = {
      // empresaId: parseInt(localStorage.getItem('empresaId')),
      empresaId: 0,
      // vendedorId: 0
      vendedorId: this.isGerente() ? 0 : parseInt(localStorage.getItem('id'))
    }

    if(this.ovFilter !== ''){
      body['ordenVentaId'] = this.ovFilter
    }

    if(this.clienteFilter !== ''){
      body['cliente'] = this.clienteFilter
    }

    if(this.folioFilter !== ''){
      body['folio'] = this.folioFilter
    }

    if(this.celularFilter !== ''){
      body['celular'] = this.celularFilter
    }

    if(this.ordenVentaFilter !== ''){
      body['ordenVentaId'] = this.ordenVentaFilter
    }

    if(this.isGerente()){
      if(this.selectedOptionsSucursales.length > 0){
        let sucursales = []
        this.selectedOptionsSucursales.forEach(element => {
          sucursales.push(element.sucursalId)
        });
        body['sucursalIdList'] = sucursales
      }
    }else{
      body['sucursalIdList'] = JSON.parse(localStorage.getItem('sucursalId'))
    }
    body['paginacion'] = this.paginator;

    this.ppService.getListaPlanProtectionTramite(body).subscribe(
      data => {
        this.listaProveedores = data.datos.items
        this.ppService.setData(this.listaProveedores);
        this.pagination = data.datos.paginacion;
        this.configurarPaginas(6);
        this.code1 = this.ppService.getInfo()
        setTimeout(() => {
          this.isLoadingView = true
          this.spinnerService.hide()
        }, 500);
      }, err => {

        this.spinnerService.hide()
      }
    )

   
    // if(opc === 2){
    //   if(this.nameFilter !== '' || this.lastNameFilter !== '' || this.emailFilter !== '' || this.userNameFilter !== ''){
    //     this.getDataEndpoint()
    //   }else{
    //     return
    //   }
    // }else{
    //   this.getDataEndpoint()
    // }
  }

  editarRegistro(item){
    if(this.isDesktop){
      const dialogRef = this.dialog.open(ErrorDialogComponent, {
        panelClass: 'custom-dialog',
        disableClose: true,
        data: {
          isError: true,
          message: 'Está funcionalidad solo se puede usar desde dispositivos móviles'
        }
      });
    }else{
      if (localStorage.getItem('profile') !== 'Gerente') {
        this.router.navigate(['pp/en-tramite/'+ item.folio])
      }
    }
  }

  nuevoPlan(){
    const dialogRef = this.dialog.open(NuevoPlanProtectionDialogComponent, {
      panelClass: 'custom-dialog',
      disableClose: true,
      width: '100vw',
      data: {
      }
    });
  }

  showAdmin(){
    return localStorage.getItem('profile') === '1' ? true : false
  }

  mostrarFiltros(){
    this.filtros = !this.filtros
  }

  private configurarPaginas(numPages: number) {
    const { floor, min, max } = Math
    const range = (lo, hi) => Array.from({ length: hi - lo }, (_, i) => i + lo)
    const pagination = (count) => (page, total) => {
      const start = max(1, min(page - floor((count - 3) / 2), total - count + 2))
      const end = min(total, max(page + floor((count - 2) / 2), count - 1))
      return [
        ... (start > 2 ? [1, '...'] : start > 1 ? [1] : []),
        ...range(start, end + 1),
        ... (end < total - 1 ? ['...', total] : end < total ? [total] : [])
      ]
    }

    const pages = pagination(numPages)(this.pagination.currentPage, this.pagination.totalPages);
    let prevPage = 0;
    this.pages = [];
    pages.map((page, index) => {
      const pageInfo: any = {
        id: (page == '...' ? prevPage + 1 : page),
        text: page
      };
      pageInfo.title = `Página ${pageInfo.id}`;
      this.pages.push(pageInfo);
      if (page != '...') {
        prevPage = parseInt(page);
      }
    });
  }

  gotoPage(page: any) {
    switch (page) {
      case '<':
        page = this.pagination.currentPage - 1;
        break;
      case '>':
        page = this.pagination.currentPage + 1;
        break;
    }
    this.paginator.page = page;
    this.paginator.pageNumber = page;
    this.getData(1);
  }

  cambioDropdown(event) {
    this.paginator.itemsPerPage = event
    this.getData(1)
  }

   isAllSelectedSucursales() {
		if (this.sucursales != undefined)
		{
			return this.selectedOptionsSucursales.length === this.sucursales.length;
		}
		return false;
  }

  isIndeterminateSucursales() {
    return this.selectedOptionsSucursales.length > 0 && this.selectedOptionsSucursales.length < this.sucursales.length;
  }

  toggleAllSucursales(event) {
		
    if (event.checked) {
        this.selectedOptionsSucursales = this.sucursales.map(sucursal => sucursal);			
    } else {
        this.selectedOptionsSucursales = [];			
    }

		setTimeout(() => {
			// this.getVendedoresDeSucusales()
		}, 1000);
  }
}
